<div class="section" >
  
    <div class="chart">

      <div>
        <div class="title">{{Title}}</div>
        <div class="sub-title">{{Title}} collected from different platforms</div>
     </div>
       </div>
       <div class="charBox">
       <div class="canvas">
        <canvas [id]="id" class="canvasStyle"  width="500px" height="263"></canvas>
        <div  [id]="'legend_'+id" ></div>
       </div>
      </div>
</div>       


